import React from 'react';
import { t, props } from 'tcomb-react';

@props({
  doShowShare: t.Bool,
  doShare: t.Func
})
export default class Share extends React.Component {

  doShare(type, evt) {
    evt.preventDefault();
    this.props.doShare(type);
  }

  render() {
    if (!this.props.doShowShare) {
      return null;
    }
    // <a className="share" onClick={this.doShare.bind(this, 'email')} title="Email" href="#"><div className="email"></div></a>
    // <a className="share" onClick={this.doShare.bind(this, 'gplus')} title="Google Plus" href="#"><div className="gplus"></div></a>
    return (
      <div id="container_share">
        <a className="share" onClick={this.doShare.bind(this, 'facebook')} title="Facebook" href="#"><div className="facebook"></div></a>
        <a className="share" onClick={this.doShare.bind(this, 'linkedin')} title="LinkedIn" href="#"><div className="linkedin"></div></a>
        <a className="share" onClick={this.doShare.bind(this, 'twitter')} title="Twitter" href="#"><div className="twitter"></div></a>
      </div>
    );
  }
}










/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/Share.js
 **/